function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.35522 15.701L5.55657 14.3413",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.84369 2.81628L3.48392 1.61494",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.81835 8.7261L0.99996 8.83858",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0224 1.46955L9.75408 4.75683C8.78614 5.01619 8.21172 6.01111 8.47108 6.97905L11.7584 19.2473C12.0177 20.2153 13.0126 20.7897 13.9806 20.5303L26.2489 17.2431C27.2168 16.9837 27.7912 15.9888 27.5319 15.0208L24.2446 2.75255C23.9852 1.78461 22.9903 1.2102 22.0224 1.46955Z",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4648 10.0691C15.1908 9.87455 15.6216 9.12836 15.427 8.4024C15.2325 7.67645 14.4863 7.24563 13.7604 7.44015C13.0344 7.63467 12.6036 8.38086 12.7981 9.10682C12.9927 9.83277 13.7388 10.2636 14.4648 10.0691Z",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5926 11.5158L21.0371 8.30825L13.9806 20.5305",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSelectPhotos(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "select-photos-icon",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPhotos);
export default __webpack_public_path__ + "static/media/select-photos.1a6d4c5c.svg";
export { ForwardRef as ReactComponent };